module.exports = "https://cdn.qantashotels.com/qantashotelsui/_next/static/images/map-generic-ec43c80bd7de6efbd2702b99947ea214.svg";